import React from 'react';

import TrailTable from '../Table';

import { useStyles } from './styles';

export default () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <TrailTable />
    </div>
  );
};
